export default __webpack_public_path__ + "static/media/wedding5.ca3689c5.webp";